module.exports = __webpack_public_path__ + "img/a.4e19c1bf.svg";